import { useQuery } from '@tanstack/react-query';
import { Button } from '@upme/ui/components/button';
import { Input } from '@upme/ui/components/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@upme/ui/components/select';
import { useState } from 'react';
import { listCitiesOptions } from '../../cities/queries';
import { useTestSend } from '../mutations';
import { morningPreviewOptions } from '../queries';

export function MorningPreviewTab() {
  const { data: cities = [] } = useQuery(listCitiesOptions());
  const [cityId, setCityId] = useState('');
  const [date, setDate] = useState('');
  const { data: preview } = useQuery(morningPreviewOptions(cityId, date || undefined));
  const testSend = useTestSend();

  return (
    <div className="space-y-4 p-4">
      <div className="flex flex-wrap items-center gap-2">
        <Select value={cityId} onValueChange={setCityId}>
          <SelectTrigger className="w-64">
            <SelectValue placeholder="Город" />
          </SelectTrigger>
          <SelectContent>
            {cities.map((c) => (
              <SelectItem key={c.id} value={c.id}>
                {c.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="w-44" />
        <Button
          disabled={!cityId || testSend.isPending}
          onClick={() => testSend.mutate({ cityId, ...(date ? { date } : {}) })}
        >
          {testSend.isPending ? 'Отправка…' : 'Отправить мне сейчас'}
        </Button>
        {testSend.isSuccess && <span className="text-sm text-green-600">Отправлено ✓</span>}
      </div>

      {preview && (
        <div className="max-w-sm overflow-hidden rounded-xl border bg-card shadow">
          {preview.imageUrl ? <img src={preview.imageUrl} alt="" className="w-full object-cover" /> : null}
          {/* caption — доверенный HTML из нашего бэка (ссылки событий, форматирование) */}
          <div
            className="whitespace-pre-wrap p-3 text-sm"
            dangerouslySetInnerHTML={{ __html: preview.caption }}
          />
        </div>
      )}
    </div>
  );
}
